<template>
    <div v-if="this.isLoading">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
    </div>
    <div v-else>
        <div style="position:sticky;top:0;z-index:20;background:#ffffff;padding:0 24px;">
            <h2 class="pb-2">{{ this.parentObject.pageTitle}}</h2>
        </div>
        <v-container>
            <v-form>
                <v-container id="scroll-target" class="custom-form overflow-y-auto px-5">
                <v-row align="center">
                    <v-col cols="8" sm="8" class="pb-n4">
                        <v-autocomplete outlined :label="$t('pmrewardsimulation.rewardrecorddesc')"  ref="rewardrecordid"
                            :rules="[rules.required]" v-model="rewardrecordid" dense :items="rewardRecordOptionList"
                            @change="changeRewardRecordOption(rewardrecordid)"
                            class="v-input"
                        ></v-autocomplete>
                    </v-col>
                    <v-col cols="4" sm="4" class="pb-n4">
                        <v-text-field outlined :label="$t('pmrewardsimulation.rewardrecordcode')" type="text" v-model="rewardCode" readonly
                            dense class="v-input" background-color="#ffeab2"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="8" sm="8" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmassementrecord.pmassessmentdesc')" type="text" v-model="assessmentDesc" readonly
                            dense class="v-input" background-color="#ffeab2"></v-text-field>
                    </v-col>
                    <v-col cols="4" sm="4" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmassementrecord.pmassessmentcode')" type="text" v-model="assessmentCode" readonly
                            dense class="v-input" background-color="#ffeab2"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmmoderation.periodfromdate')" type="text" v-model="assessmentFromDate" readonly
                            dense class="v-input" background-color="#ffeab2"></v-text-field>
                    </v-col>
                    <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmmoderation.perioduntildate')" type="text" v-model="assessmentUntilDate" readonly
                            dense class="v-input" background-color="#ffeab2"></v-text-field>
                    </v-col>
                    <v-col cols="2" sm="2" class="pb-n4 mt-n8">
                        <v-text-field outlined :label="$t('pmrewardsimulation.rewardstatus')" type="text" v-model="rewardStatus" readonly
                            dense class="v-input" background-color="#ffeab2"></v-text-field>
                    </v-col>
                </v-row>
                <v-row>
                    <v-btn color="primary" v-on:click="simulateRewardHandler">{{ $t('pmrewardsimulation.simulatereward') }}</v-btn>
                </v-row>
                <div>
                    <app-error
                        v-if="isErrorDialogOpen"
                        :key="errorkey"
                        :parentError="errorDialogData"
                    />
                </div>
                </v-container>
            </v-form>
        </v-container>
    </div>
</template>

<script>
import moment from 'moment';
import ErrorDialog from "../../../components/common/ErrorDialog.vue";

export default {
    props: {
        parentObject: Object
    },

    components: {
        "app-error": ErrorDialog,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
            },

            // formData: {
            //     id: this.parentObject.data.id,
            //     simulationcode: this.parentObject.data.simulationcode,

            //     updatedby: this.$store.getters.userId,
            // },

            errMsg: '',
            isErr: false,
            isEdit: this.parentObject.isEdit,
            isAdvanceEdit: this.parentObject.isAdvanceEdit,
            isLoading: true,

            //This ID is used to get the data from the database
            rewardrecordid:null,
            //after getting Data, update this below
            rewardCode: null,
            assessmentDesc: null,
            assessmentCode: null,
            assessmentFromDate: null,
            assessmentUntilDate: null,
            rewardStatus: null,

            assessmentrecordid: null,
            isLocked: false,
            instructionIsExist : false,


            rewardRecordOptionList: [], // take necessary data only from Full
            rewardRecordOptionFull: [],// get full data from database

            isErrorDialogOpen: false,
            errorDialogData: {
                isErr: false,
                data: "",
            },
            errorkey: 0,//this is use to force open and close the confirm dialog
        }
    },

    methods: {
        simulateRewardHandler() {
          
            if(!this.instructionIsExist)// no exsits then we tell user to edit first
            {
                this.isErrorDialogOpen= false;//reset to close
                this.errorkey++;
                this.errorDialogData.isErr = true;
                this.errorDialogData.data = this.$t('pmrewardsimulation.noinstruction');
                this.isErrorDialogOpen = true;// open the dialog
                return;//force stop
            }

            if(!this.isLocked)
            {
                this.isErrorDialogOpen= false;//reset to close
                this.errorkey++;
                this.errorDialogData.isErr = true;
                this.errorDialogData.data = this.$t('pmrewardsimulation.nolocked');
                this.isErrorDialogOpen = true;// open the dialog
            }
            else
            {
                this.$router.push({
                    name: 'pmrewardsimulationedit',
                    params: {
                        lang: this.$route.params.lang,  // or a specific value like 'en'
                        rewardid: this.rewardrecordid,
                        assessmentid: this.assessmentrecordid
                    }
                });
            }
        },

        async loadPmRewardRecordListHandler() {
            try {
                const res = await this.$store.dispatch('get', { url: "/pmrewardrecord/all" });
                this.rewardRecordOptionFull = res.data.rec;
                this.rewardRecordOptionList = []; // Clear the list before pushing new items

                for (let i = 0; i < res.data.rec.length; i++) {
                        this.rewardRecordOptionList.push({
                            text: res.data.rec[i].simulationdesc,
                            value: res.data.rec[i].id,
                        });
                }                
            } catch (err) {
                this.isErr = true;
                this.errMsg = err;
                this.$emit("error", { isErr: this.isErr, errMsg: this.errMsg });
            }
        },

        async changeRewardRecordOption(id) {
            let item = this.rewardRecordOptionFull.find((item) => item.id === id);
            this.rewardCode = item.simulationcode;
            this.assessmentDesc = item.pmassessmentrecorddesc;
            this.assessmentCode = item.pmassessmentrecordcode;
            this.assessmentFromDate =   moment(item.pmassestartdate).format('YYYY-MM-DD');
            this.assessmentUntilDate =  moment(item.pmasseenddate).format('YYYY-MM-DD');
            this.rewardStatus = item.rewardstatuscode;
            
            this.assessmentrecordid= item.assessmentrecordid;
            if(item.rewardstatuscode == "LOCKED"){
                this.isLocked = true;
            }else{
                this.isLocked = false;
            }

            const res = await this.$store.dispatch('get', { url: "/pmrewardinstruction/"+id });
            if(res.data.rec == null)
            {
                //console.log("No record found ask user to update instruction");
                this.instructionIsExist = false;
            }
            else if(res.data.rec !=null)
            {
                this.instructionIsExist = true;
                //console.log("Record found , all set to go")
            }
        },
    },
    async mounted() {
        try {
            await this.loadPmRewardRecordListHandler();        
            this.isLoading = false;
        } catch (error) {
            console.error("Error loading data:", error);
        }
    }
}
</script>